import React from 'react';

const PageTitle404 = () => {
    return (
        <div id="page-title">
            <div className="wrapper text-center">
                <h1 className="large">404</h1>
            </div>
        </div>
    );
};

export default PageTitle404;
